import { REPEAT_MODE } from '../constants'
import { normalizeDaysOfMonth } from '../adapters/mapRepeatToApi'
import { validateHighFrequencyRepeatLimits } from './repeatLimits'

export const validateRepeat = (schedule, scheduleIndex) => {
  const errors = {}
  const repeat = schedule?.repeat || {}
  const prefix = `schedules.${scheduleIndex}.repeat`
  if (!repeat.mode) {
    errors[`${prefix}.mode`] = 'Select a repeat mode.'
    return errors
  }
  if (repeat.mode === REPEAT_MODE.everyNDays) {
    if (!Number(repeat.intervalDays) || Number(repeat.intervalDays) < 1) {
      errors[`${prefix}.intervalDays`] = 'Enter every N days (1 or greater).'
    }
  }
  if (repeat.mode === REPEAT_MODE.weeklyOnSelectedDays) {
    if (!Array.isArray(repeat.weekdays) || !repeat.weekdays.length) {
      errors[`${prefix}.weekdays`] = 'Select at least one weekday.'
    }
  }
  if (repeat.mode === REPEAT_MODE.everyNWeeks) {
    if (!Number(repeat.intervalWeeks) || Number(repeat.intervalWeeks) < 1) {
      errors[`${prefix}.intervalWeeks`] = 'Enter every N weeks (1 or greater).'
    }
  }
  if (repeat.mode === REPEAT_MODE.everyNMonths) {
    if (!Number(repeat.months) || Number(repeat.months) < 1) {
      errors[`${prefix}.months`] = 'Enter every N months (1 or greater).'
    }
  }
  if (repeat.mode === REPEAT_MODE.monthlyOnDay) {
    if (!Number(repeat.months) || Number(repeat.months) < 1) {
      errors[`${prefix}.months`] = 'Enter every N months (1 or greater).'
    }
    if (Array.isArray(repeat.daysOfMonth) && repeat.daysOfMonth.length) {
      if (repeat.daysOfMonth.some(day => Number(day) < 1 || Number(day) > 31)) {
        errors[`${prefix}.daysOfMonth`] = 'Each day must be between 1 and 31.'
      }
    } else {
      const day = Number(repeat.dayOfMonth)
      if (!day || day < 1 || day > 31) {
        errors[`${prefix}.dayOfMonth`] = 'Enter a calendar day between 1 and 31.'
      }
    }
  }
  if (repeat.mode === REPEAT_MODE.chapterIntervalExplicit) {
    const list = repeat.chapterIntervals || []
    if (!list.length) {
      errors[`${prefix}.chapterIntervals`] = 'Add at least one explicit chapter interval.'
    }
  }
  return { ...errors, ...validateHighFrequencyRepeatLimits(schedule, scheduleIndex) }
}
